import { useEffect, useState } from 'react';

const TICK_MS = 30_000;

export const useTimeLeft = (deadline: string | null | undefined) => {
  const [now, setNow] = useState<number>();

  useEffect(() => {
    if (!deadline) return;

    setNow(Date.now());
    const interval = window.setInterval(() => setNow(Date.now()), TICK_MS);
    return () => window.clearInterval(interval);
  }, [deadline]);

  if (!deadline || now === undefined) return null;

  const msLeft = new Date(deadline).getTime() - now;
  return msLeft > 0 ? msLeft : null;
};
